"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import {ownerBuilderPermitStatusOptions, buildingInspectionStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext } from "react-hook-form"
const baseFieldName = "home.permitInspectionStatusInfo"

function HomePermitInspectionStatusForm() {
    const { control } = useFormContext<HomeWithHomeOwnerFormType>()
    return (
        <HomeDetailsWrapperAccordion heading="Permit & Inspection Status">
            {/* row 1 */}
            <FormTextInput
                inputGroupProps={{
                    label: "Roofing Permit Number"
                }}
                placeholder="Roofing Permit Number"
                name={`${baseFieldName}.roofingPermitNumber`}
                control={control}
            />
            {/* row 2 */}
            <FormSelectInput
                inputGroupProps={{
                    label: "501 Roofing Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.roofingInspections501`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "503 Roofing",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.roofingInspections503`}
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "Permit Applicant"
                }}
                placeholder="Permit Applicant"
                name={`${baseFieldName}.permitApplicant`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "Owner Builder Permit Status",
                }}
                options={ownerBuilderPermitStatusOptions}
                name={`${baseFieldName}.builderPermitStatus`}
                control={control}
            />
            {/* row 4 */}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Permit Description",
                    wrapperClassName: "three-cols"
                }}
                rows={4}
                name={`${baseFieldName}.permitDescription`}
                control={control}
            />
            {/* row 5 */}
            <FormTextInput
                inputGroupProps={{
                    label: "Owner Builder Permit Number",
                }}
                placeholder="Owner Builder Permit Number"
                name={`${baseFieldName}.ownerBuilderPermitNumber`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "105 Rough Framing Structural Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.framingInspections105`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "107 Insulation Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.insulationInspections107`}
                control={control}
            />
            {/* row 6 */}
            <FormSelectInput
                inputGroupProps={{
                    label: "202 Tub Set Plumbing Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.plumbingInspections202`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label:"204 Plumbing Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.plumbingInspections204`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "304 Electrical Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.electricalInspections304`}
                control={control}
            />
            {/* row 7 */}
            <FormSelectInput
                inputGroupProps={{
                    label: "305 Electrical Inspections",
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.electricalInspections305`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "401 HVAC Mechanical Inspections"
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.hvacInspections401`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label:"402 HVAC Mechanical Inspections"
                }}
                options={buildingInspectionStatusOptions}
                name={`${baseFieldName}.hvacInspections402`}
                control={control}
            />
            {/* row 8 */}
            <div className="three-cols inputs-wrapper three-cols-grid">
                <FormSelectInput
                    inputGroupProps={{
                        label: "Drywall Inspections"
                    }}
                    options={buildingInspectionStatusOptions}
                    name={`${baseFieldName}.drywallInspections`}
                    control={control}
                />
                <FormSelectInput
                    inputGroupProps={{
                        label: "125 Shutters Inspections"
                    }}
                    options={buildingInspectionStatusOptions}
                    name={`${baseFieldName}.shutterInspections125`}
                    control={control}
                />
                <FormSelectInput
                    inputGroupProps={{
                        label: "106 Final Inspection"
                    }}
                    options={buildingInspectionStatusOptions}
                    name={`${baseFieldName}.finalInspection106`}
                    control={control}
                />
            </div>
        </HomeDetailsWrapperAccordion>
    )
}

export default HomePermitInspectionStatusForm
